/**
 * Generated by orval v7.18.0 🍺
 * Do not edit manually.
 * MobiViz
 * The MobiViz API description (multi-version)
 * OpenAPI spec version: 1.0.0
 */
import { fetchApi } from "../../../fetch";
import type { InitialMapStateDto } from "../../models";

export const getSettingsControllerGetInitialMapStateV0Url = () => {
  return `/api/v0/settings/initial-map-state`;
};

export const settingsControllerGetInitialMapStateV0 = async (
  options?: RequestInit,
): Promise<InitialMapStateDto> => {
  return fetchApi<InitialMapStateDto>(
    getSettingsControllerGetInitialMapStateV0Url(),
    {
      ...options,
      method: "GET",
    },
  );
};
